import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPaymentMir = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 10"
    {...props}
  >
    <path
      d="M23.892 4.642v5.041h2.755V6.696h3.123c1.314-.01 2.43-.864 2.852-2.054h-8.73z"
      fill="#37A72E"
    />
    <path
      d="M23.892.517c.16 2.049 2.061 3.666 4.384 3.666h4.752c.035-.188.053-.382.053-.58 0-1.697-1.343-3.074-3.006-3.086h-6.183z"
      fill="url(#payment-mir_svg__a)"
    />
    <path
      d="m19.366 4.162.002-.005a.17.17 0 0 1 .318.078v5.448h2.827V.517h-2.827c-.359.011-.764.273-.914.593l-2.25 4.79a.183.183 0 0 1-.026.053v.002a.189.189 0 0 1-.344-.107V.517h-2.828v9.166h2.828c.354-.02.75-.277.898-.593l2.31-4.915a.176.176 0 0 1 .006-.013zm-10.09.157L7.658 9.683H5.667L4.048 4.316a.183.183 0 0 0-.179-.151.183.183 0 0 0-.182.187v5.331H.919V.517h3.083c.51 0 1.043.4 1.192.894l1.347 4.467c.067.222.176.222.243 0L8.13 1.41c.15-.493.683-.893 1.193-.893h3.082v9.166H9.638V4.349a.183.183 0 0 0-.183-.184.183.183 0 0 0-.18.154z"
      fill="#37A72E"
    />
    <defs>
      <linearGradient
        id="payment-mir_svg__a"
        x1={23.892}
        y1={4.183}
        x2={33.081}
        y2={4.183}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0E5" />
        <stop offset={1} stopColor="#0077C3" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgPaymentMir);
export default Memo;
